export const CLIENT_TYPE_DEBATER = 'Debater';
export const CLIENT_TYPE_INSTITUTION = 'Institution';
export const CLIENT_TYPE_ADJUDICATOR = "Adjudicator";

export const CLIENT_TYPES = [
    { label: 'Debater', value: CLIENT_TYPE_DEBATER },
    { label: 'Institution', value: CLIENT_TYPE_INSTITUTION },
    { label: 'Adjudicator', value: CLIENT_TYPE_ADJUDICATOR },
]